const MuiFormControl = {
  styleOverrides: {
    root: {
      marginTop: 0,
    },
  },
};

export default MuiFormControl;
